<template>
	<div
		class="g-block-body-frame-icon g-block-body-padding"
		:class="{
			'g-block-body-frame-icon--edit': editable,
			'is-active': editable && active,
			'g-block-body-frame-icon--h5': h5,
			'g-block-body-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div
			class="g-block-body-frame-icon__frame"
			:style="{ borderColor }"
		>
			<div class="g-block-body-frame-icon__deco" aria-hidden="true">
				<div class="g-block-body-frame-icon__deco-inner">
					<span
						v-for="index in 3"
						:key="index"
						class="g-block-body-frame-icon__slant"
						:class="{
							'g-block-body-frame-icon__slant--side': index !== 2,
							'g-block-body-frame-icon__slant--mid': index === 2,
						}"
						:style="{ borderColor: accentColor }"
					></span>
				</div>
			</div>
			<RichTextEditable
				v-if="editable"
				class="g-block-body-frame-icon__text"
				:model-value="data.content"
				placeholder="请输入正文"
				@update:model-value="onContentUpdate"
				@focus="onWrapClick"
			/>
			<div
				v-else
				class="g-block-body-frame-icon__text"
				v-html="data.content || ''"
			></div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { getBodyFrameIconColors } from '../../../templates.js';
	import { bodyMixin } from '../shared/bodyMixin.js';

	export default {
		name: 'GBlockBodyFrameIcon',
		components: { RichTextEditable },
		mixins: [bodyMixin],
		computed: {
			frameColors() {
				return getBodyFrameIconColors(this.data);
			},
			borderColor() {
				return this.frameColors[0];
			},
			accentColor() {
				return this.frameColors[1];
			},
		},
	};
</script>

<style scoped lang="less">
	@import '../shared/bodyEditShell.less';

	.g-block-body-frame-icon {
		.body-block-edit-shell();
	}

	.g-block-body-frame-icon__frame {
		position: relative;
		border: 1px solid;
		padding: 18px 14px 14px;
		box-sizing: border-box;
	}

	.g-block-body-frame-icon__deco {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		display: flex;
		justify-content: center;
		transform: translateY(-50%);
		pointer-events: none;
	}

	.g-block-body-frame-icon__deco-inner {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 4px;
		padding: 0 10px;
		background: #fff;
		line-height: 0;
	}

	.g-block-body-frame-icon__slant {
		display: block;
		width: 0;
		border-left: 3px solid;
		transform: skewX(-18deg);
		transform-origin: center center;
		flex-shrink: 0;

		&--side {
			height: 10px;
		}

		&--mid {
			height: 16px;
		}
	}

	.g-block-body-frame-icon__text {
		.body-text-base();
	}

	.g-block-body-frame-icon--h5 {
		.g-block-body-frame-icon__frame {
			padding: 0.36rem 0.28rem 0.28rem;
		}
		.g-block-body-frame-icon__deco-inner {
			gap: 0.08rem;
			padding: 0 0.2rem;
		}
		.g-block-body-frame-icon__slant {
			border-left-width: 0.06rem;

			&--side {
				height: 0.2rem;
			}

			&--mid {
				height: 0.32rem;
			}
		}
		.body-text-base--h5(~'.g-block-body-frame-icon__text');
	}
</style>
